module.exports = __webpack_public_path__ + "img/product-02.570b4bf4.jpg";